module.exports = {
    graphAPIEndpoints: {
        masterchef: 'https://api.thegraph.com/subgraphs/name/lufycz/masterchef-vesting',
        bar: 'https://api.thegraph.com/subgraphs/name/kaaldhairya/barkovanv1',//'https://api.thegraph.com/subgraphs/name/sushiswap/sushi-bar',
        timelock: 'https://api.thegraph.com/subgraphs/name/sushiswap/sushi-timelock',
        maker: 'https://api.thegraph.com/subgraphs/name/sushiswap/sushi-maker',
        exchange: 'https://api.thegraph.com/subgraphs/name/shibaswaparmy/exchange',
        exchange_v1: 'https://api.thegraph.com/subgraphs/name/shibaswaparmy/exchange',
        blocklytics: 'https://api.thegraph.com/subgraphs/name/blocklytics/ethereum-blocks',
        lockup: 'https://api.thegraph.com/subgraphs/name/matthewlilley/lockup',
        topdog: 'https://gateway.thegraph.com/api/849f51a1caa5e40bb6d0d0172264cd6c/subgraphs/id/GHgCTafoihGNzwLWf6vpx78m5dmpzfQyEAhC5qxMvE9h',
        buryShib: 'https://gateway.thegraph.com/api/849f51a1caa5e40bb6d0d0172264cd6c/subgraphs/id/Fs3i2jKVvKQyLXQPWmVHVXWKmnKwiynZN5qspF3CBcKn',
        buryLeash: 'https://gateway.thegraph.com/api/849f51a1caa5e40bb6d0d0172264cd6c/subgraphs/id/Emofvmi5CUm2W21eZBManTNFhYKhTB1mSTasrfFHrVoV',
        buryBone: 'https://gateway.thegraph.com/api/849f51a1caa5e40bb6d0d0172264cd6c/subgraphs/id/D68PHr4fh88q9KPKS67RbwzUeGcq7owwSSjVQiCnhpbG',
        buryShibWETHVesting: 'https://api.thegraph.com/subgraphs/name/shibaswaparmy/xshibwethrewards',
        buryShibBoneVesting: 'https://api.thegraph.com/subgraphs/name/shibaswaparmy/xshibbonerewards',
        buryBoneBoneVesting: 'https://api.thegraph.com/subgraphs/name/shibaswaparmy/tbonebonerewards',
        buryLeashBoneVesting: 'https://api.thegraph.com/subgraphs/name/shibaswaparmy/xleashbonerewards',
        swapUSDCRewardsVesting: 'https://api.thegraph.com/subgraphs/name/shibaswaparmy/usdcswaprewards',
        swapUSDTRewardsVesting: 'https://api.thegraph.com/subgraphs/name/shibaswaparmy/usdtswaprewards',
        swapDAIRewardsVesting: 'https://api.thegraph.com/subgraphs/name/shibaswaparmy/daiswaprewards',
        swapWBTCRewardsVesting: 'https://api.thegraph.com/subgraphs/name/shibaswaparmy/wbtcswaprewards',
        swapXFUNDRewardsVesting: 'https://api.thegraph.com/subgraphs/name/shibaswaparmy/xfundrewards',
        swapF9RewardsVesting: 'https://api.thegraph.com/subgraphs/name/shibaswaparmy/f9rewards',
        swapRyoRewardsVesting: 'https://api.thegraph.com/subgraphs/name/shibaswaparmy/ryorewards',
        swapRyoRewards2Vesting: 'https://api.thegraph.com/subgraphs/name/k1ngarthurmeng/ryo-rewards-distributor',
        swapZigRewardsVesting: 'https://api.thegraph.com/subgraphs/name/shibaswaparmy/zigrewards',
        swapPerlRewardsVesting: 'https://api.thegraph.com/subgraphs/name/shibaswaparmy/perlrewards',
        swapCivRewardsVesting: 'https://api.thegraph.com/subgraphs/name/shibaswaparmy/civrewards',
        allBoneRewardsVesting: 'https://api.thegraph.com/subgraphs/name/shibaswaparmy/newbonerewards',
        swapVempRewardsVesting: 'https://api.thegraph.com/subgraphs/name/shibaswaparmy/vemprewards',
        swapUFORewardsVesting: 'https://api.thegraph.com/subgraphs/name/shibaswaparmy/uforewards'
    },

    graphWSEndpoints: {
        bar: 'wss://api.thegraph.com/subgraphs/name/sushiswap/sushi-bar',
        exchange: 'wss://api.thegraph.com/subgraphs/name/sushiswap/exchange',
        blocklytics: 'wss://api.thegraph.com/subgraphs/name/blocklytics/ethereum-blocks'
    },

    barAddress: "0x8798249c2e607446efb7ad49ec89dd1865ff4272",
    makerAddress: "0xe11fc0b43ab98eb91e9836129d1ee7c3bc95df50",
    chefAddress: "0xc2edad668740f1aa35e4d8f227fb8e17dca888cd",
    sushiAddress: "0x6b3595068778dd592e39a122f4f5a5cf09c90fe2",
    factoryAddress: "0x842e15348eea1391698f82f8bd29f728bd71b20b",

    TWENTY_FOUR_HOURS: 86400,
    // TODO KOVAN => MAINNET => CHANGE => non checksummed
    topdogAddress : "0x94235659cf8b805b2c658f9ea2d6d6ddbb17c8d7",
    boneAddress : "0x9813037ee2218799597d83d4a5b6f3b6778218d9",
    shibAddress : "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce",
    leashAddress : "0x27c70cd1946795b66be9d954418546998b546634",
    shibaswapFactoryAddress : "0x115934131916c8b277dd010ee02de363c09d037c",
    buryShibStartBlock: 25079266,
    buryLeashStartBlock: 25079266,
    buryBoneStartBlock: 25079266,
    buryShibEndBlock: 25079266,
    buryLeashEndBlock: 25079266,
    buryBoneEndBlock: 25079266,
    REWARD_POOL_IDS: [1, 15]
}
